/* hs-eslint ignored failing-rules */

'use es6';

import PropTypes from 'prop-types';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import ReportNameField from '../../shared/inputFields/ReportNameField';
import { getName, getId as getReportId } from '../../../data/schemas/reportSchema';
import { useHideDialog } from '../../../dialog/ducks';
import { useMutation } from 'data-fetching-client';
import { RENAME_REPORT } from '../../../data/requests/report';
import { getDefaultSavedReportActionEventProperties } from '../../report-action-wrapper';
import { useTracker } from '../../../utils/hooks/useTracker';
import { EVENTS } from '../../../utils/usageTracker';
import { useUserRoleForReport } from '../../../utils/trackingUtils';
import { useState } from 'react';
import { noop } from '../../shared/noop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RenameReportModal = ({
  appUsageTracker,
  report,
  onRenameReportSuccess = noop
}) => {
  const hideDialog = useHideDialog();
  const [renameReportMutation] = useMutation(RENAME_REPORT);
  const usageTracker = useTracker(appUsageTracker);
  const reportName = report ? getName(report) : null;
  const [name, setName] = useState(reportName);
  const [validationError, setValidationError] = useState(null);
  const userRole = useUserRoleForReport(report);
  const handleConfirm = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.completeAssetUpdate, Object.assign({}, getDefaultSavedReportActionEventProperties(report), {
        action: 'rename',
        actionType: 'save',
        object: 'name',
        role: userRole
      }));
    }
    const renamedReport = report.set('name', name);
    renameReportMutation({
      variables: {
        reportId: getReportId(report),
        renamedReport
      }
    }).then(() => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "reporting-action-components.actions.rename.modal.success",
          options: {
            reportName: name
          }
        }),
        type: 'success',
        'data-test-id': 'report-save-success-alert'
      });
      onRenameReportSuccess(renamedReport);
    }, () => ReportActionsFloatingAlertStore.addAlert({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.rename.modal.failure"
      }),
      type: 'danger'
    })).then(() => {
      hideDialog();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "report-rename-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: hideDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.rename.modal.message"
        })
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(ReportNameField, {
        reportName: name,
        onChange: setName,
        onValidationError: setValidationError
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: !validationError,
        title: validationError,
        children: /*#__PURE__*/_jsx(Button, {
          use: "primary",
          onClick: handleConfirm,
          disabled: !!validationError,
          "data-test-id": "report-save-confirm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.actions.rename.modal.confirm"
          })
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: hideDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.rename.modal.reject"
        })
      })]
    })]
  });
};
RenameReportModal.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  report: PropTypes.object.isRequired,
  onRenameReportSuccess: PropTypes.func
};
export default RenameReportModal;